import * as React from 'react';
export const Globus = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#4F5794"
      d="M9 16.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Zm-1.718-1.75a13.424 13.424 0 0 1-1.262-5H3.047a6.006 6.006 0 0 0 4.236 5Zm.24-5c.114 1.83.636 3.547 1.478 5.064a11.929 11.929 0 0 0 1.477-5.064H7.522Zm7.431 0H11.98a13.424 13.424 0 0 1-1.263 5 6.006 6.006 0 0 0 4.236-5ZM3.047 8.25H6.02c.094-1.733.523-3.43 1.263-5a6.006 6.006 0 0 0-4.237 5Zm4.476 0h2.954A11.927 11.927 0 0 0 9 3.186 11.929 11.929 0 0 0 7.522 8.25h.001Zm3.194-5a13.425 13.425 0 0 1 1.263 5h2.973a6.006 6.006 0 0 0-4.236-5Z"
    />
  </svg>
);
